
import React from 'react'

import { Container } from '@mui/material'
import { CoursesCollection, Header, IntractiveLearning } from './components'
import { Footer } from 'components'

export const Courses = ({check_auth}) => {
    return (
        <>
            <Header check_auth={check_auth} />
            <Container maxWidth='xl'>
                <IntractiveLearning />
                <CoursesCollection />
            </Container>
            <Footer />
        </>
    )
}
